// Libs
import React from 'react';
import { useTheme } from '@material-ui/core/styles';

// Utils
import { ERROR_LEVEL, INFORMATION_LEVEL, LEVEL_COLORS, SUCCESS_LEVEL, UNKNOWN_LEVEL, WARNING_LEVEL } from 'UTILS/constants';
import InfoIcon from '@material-ui/icons/Info';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import Box from '@material-ui/core/Box';

const UnknownIcon = () => {
  const theme = useTheme();
  return (
    <Box className='resultIcon-unknownIcon' color={theme.palette.success.dark} bgcolor={theme.palette.background.paper} />
  );
};

const LEVEL_ICONS = {
  [UNKNOWN_LEVEL]: UnknownIcon,
  [SUCCESS_LEVEL]: CheckCircleIcon,
  [INFORMATION_LEVEL]: InfoIcon,
  [WARNING_LEVEL]: WarningIcon,
  [ERROR_LEVEL]: WarningIcon,
};

const ResultIcon = ({ resultLevel, fillColor }) => {
  const theme = useTheme();
  const Icon = LEVEL_ICONS[resultLevel];
  return Icon ? (
    <span>
      <span style={{ backgroundColor: fillColor }}>
        <Icon htmlColor={theme.palette[LEVEL_COLORS[resultLevel]].dark} />
      </span>
    </span>
  ) : null;
};

export default ResultIcon;
